import PageHeading from '../components/common/PageHeading';

const horseClubItems = [
  {
    title: '주변 승마장 탐색',
    body: '현재 위치나 관심 지역을 기준으로 가까운 승마장 정보를 빠르게 확인합니다.',
  },
  {
    title: '프로그램 비교',
    body: '체험, 강습, 정기 이용권처럼 목적에 맞는 프로그램과 가격 정보를 살펴봅니다.',
  },
  {
    title: '예약 가능 시간 확인',
    body: '방문 가능한 날짜와 시간대를 확인하고 앱 예약 흐름으로 자연스럽게 이어갑니다.',
  },
  {
    title: '시설 정보 확인',
    body: '승마장 소개, 운영 정보, 편의시설을 한눈에 보고 방문 전 필요한 내용을 챙깁니다.',
  },
];

function HorseClubPage() {
  return (
    <section className="horseclub-page" aria-labelledby="horseclub-title">
      <PageHeading
        id="horseclub-title"
        label="승마장검색"
        title="가까운 승마장을 빠르게 찾아보세요"
        description="지역, 프로그램, 예약 가능 정보를 기준으로 나에게 맞는 승마장을 찾을 수 있습니다."
      />
      <div className="service-grid">
        {horseClubItems.map((item) => (
          <article className="surface-card" key={item.title}>
            <h2>{item.title}</h2>
            <p>{item.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default HorseClubPage;
